module.exports = __webpack_public_path__ + "static/media/ended-class-tips3.f48789d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ended-class-tips3.png
// module id = 1976
// module chunks = 6